"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengesCustomForm = ChallengesCustomForm;
exports.CustomChallengeFormTypeCard = CustomChallengeFormTypeCard;
var _ButtonBase2 = _interopRequireDefault(require("@mui/material/ButtonBase"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Card2 = _interopRequireDefault(require("@mui/material/Card"));
var _CardContent2 = _interopRequireDefault(require("@mui/material/CardContent"));
var _InputAdornment2 = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _InfoOutlined2 = _interopRequireDefault(require("@mui/icons-material/InfoOutlined"));
var _formik = require("formik");
var _moment = _interopRequireDefault(require("moment"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var Yup = _interopRequireWildcard(require("yup"));
var _components = require("../components");
var _hooks = require("../hooks");
var _models = require("../models");
var _services = require("../services");
var _cancelChallengeEditionDialog = _interopRequireDefault(require("./cancel-challenge-edition-dialog"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ChallengesCustomForm({
  Button: _Button,
  Link,
  prevPath,
  challenge,
  currentPartner,
  drawerWidth,
  onCreated,
  onRedirect
}) {
  const [cancelDialogOpen, openCancelDialog] = (0, _react.useState)(false);
  const [file, setFile] = (0, _react.useState)(challenge?.photo ? {
    url: `${challenge.photo}`,
    name: challenge.photo.substring(challenge.photo.lastIndexOf('/') + 1)
  } : undefined);
  const {
    isValid,
    isSubmitting,
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    validateForm
  } = (0, _formik.useFormik)({
    initialValues: {
      title: challenge?.title || '',
      description: challenge?.description || '',
      startDate: challenge?.startDate.format('YYYY-MM-DD') || '',
      endDate: challenge?.endDate.format('YYYY-MM-DD') || '',
      type: challenge?.type || 'traveledDistance',
      collaborationType: challenge ? challenge.subGroupDisplay === 'companySite' ? 'sites' : challenge.subGroupDisplay ? 'teams' : challenge.collaborationType : 'individual',
      target: challenge?.targetValue ? challenge?.type === 'traveledDistance' ? challenge?.targetValue / 1000 : challenge?.targetValue : ''
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required().test('len', '', val => val ? val.toString().length <= 40 : false),
      description: Yup.string().test('len', '', val => val ? val.toString().length <= 500 : true),
      startDate: Yup.string().required(),
      endDate: Yup.string().required(),
      target: Yup.number().when('global', {
        is: 'teams',
        then: schema => schema.required()
      })
    }),
    onSubmit,
    enableReinitialize: true
  });
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    validateForm();
    return () => cancelPromises();
  }, []);
  async function onSubmit({
    title,
    description,
    startDate,
    endDate,
    type,
    target,
    collaborationType
  }) {
    if (!currentPartner) return;
    const challengeTypes = {
      traveledDistance: 'TRAVELED_DISTANCE',
      cyclingDays: 'CYCLING_DAYS',
      homeWorkJourneysCount: 'TRACES_COUNT',
      journeysCount: 'TRACES_COUNT'
    };
    try {
      let newChallenge;
      if (challenge) {
        const isStarted = (0, _moment.default)(startDate).isBefore((0, _moment.default)());
        const data = {
          id: challenge.id,
          title,
          description,
          ...(!isStarted && !challenge.eventId ? {
            collaboration_type: collaborationType === 'global' ? 'EVERYONE' : 'INDIVIDUAL',
            start_datetime: (0, _moment.default)(startDate).startOf('day').format(),
            end_datetime: (0, _moment.default)(endDate).endOf('day').format(),
            target_type: challengeTypes[type],
            trace_type: 'ALL',
            target_value: !target ? undefined : type === 'traveledDistance' ? target * 1000 : target,
            default_sub_group_display: collaborationType === 'teams' ? 'COMPANY_DEPARTMENT' : collaborationType === 'sites' ? 'COMPANY_SITE' : null
          } : {})
        };
        newChallenge = await cancellablePromise(_services.GeogroupService.updateChallenge(currentPartner, data, file instanceof File ? file : undefined));
      } else {
        newChallenge = await cancellablePromise(_services.GeogroupService.addChallenge(currentPartner, {
          title,
          description,
          collaboration_type: collaborationType === 'global' ? 'EVERYONE' : 'INDIVIDUAL',
          default_sub_group_display: collaborationType === 'teams' ? 'COMPANY_DEPARTMENT' : collaborationType === 'sites' ? 'COMPANY_SITE' : null,
          start_datetime: (0, _moment.default)(startDate).startOf('day').format(),
          end_datetime: (0, _moment.default)(endDate).endOf('day').format(),
          target_type: challengeTypes[type],
          trace_type: 'ALL',
          target_value: typeof target === 'number' ? type === 'traveledDistance' ? target * 1000 : target : undefined
        }, file instanceof File ? file : undefined));
      }
      enqueueSnackbar(t('commons.challenge_post.form.success', {
        context: challenge ? 'update' : ''
      }));
      onCreated(newChallenge);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.challenge_post.form.server_error', {
          context: challenge ? 'update' : ''
        }), {
          variant: 'error'
        });
      }
    }
  }
  function handleCancelDialogClose(leave) {
    openCancelDialog(false);
    if (leave) onRedirect();
  }
  if (challenge?.period === 'past') return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const Button = _Button || _components.Button;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "stretch",
    component: "form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement(_Card2.default, {
    elevation: 0,
    sx: {
      alignSelf: 'stretch',
      borderRadius: 4,
      marginBottom: '58px'
    }
  }, /*#__PURE__*/_react.default.createElement(_CardContent2.default, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      padding: 3
    }
  }, challenge?.period === 'current' && /*#__PURE__*/_react.default.createElement(_components.InfoCard, {
    iconBackground: true,
    description: t('commons.challenge_post.form.current_info'),
    descriptionProps: {
      color: 'inherit',
      variant: 'body2'
    },
    elevation: 0,
    Icon: _InfoOutlined2.default,
    iconProps: {
      color: 'secondary'
    },
    sx: {
      backgroundColor: '#eef8f4',
      borderRadius: '16px',
      padding: '8px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.125rem",
    fontWeight: 700
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.challenge_post.form.subtitle"
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    required: true,
    disabled: isSubmitting || challenge?.period === 'current' || Boolean(challenge?.eventId),
    error: touched.startDate && Boolean(errors.startDate),
    id: "startDate",
    label: t('commons.challenge_post.form.start_date'),
    margin: "dense",
    name: "startDate",
    onBlur: handleBlur,
    onChange: handleChange,
    size: "small",
    slotProps: {
      htmlInput: {
        min: (0, _moment.default)().add(1, 'day').format('YYYY-MM-DD')
      },
      inputLabel: {
        shrink: true
      }
    },
    type: "date",
    value: values.startDate,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    required: true,
    disabled: isSubmitting || challenge?.period === 'current' || Boolean(challenge?.eventId),
    error: touched.endDate && Boolean(errors.endDate),
    id: "endDate",
    label: t('commons.challenge_post.form.end_date'),
    margin: "dense",
    name: "endDate",
    onBlur: handleBlur,
    onChange: handleChange,
    size: "small",
    slotProps: {
      htmlInput: {
        min: values.startDate || (0, _moment.default)().add(1, 'day').format('YYYY-MM-DD')
      },
      inputLabel: {
        shrink: true
      }
    },
    type: "date",
    value: values.endDate,
    variant: "outlined"
  })), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    required: true,
    disabled: isSubmitting,
    error: touched.title && Boolean(errors.title),
    id: "title",
    label: t('commons.challenge_post.form.name'),
    margin: "none",
    name: "title",
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: t('commons.challenge_post.form.name_placeholder'),
    size: "small",
    slotProps: {
      htmlInput: {
        maxLength: 40
      },
      inputLabel: {
        shrink: true
      }
    },
    value: values.title,
    variant: "outlined"
  }), /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    multiline: true,
    disabled: isSubmitting,
    error: touched.description && Boolean(errors.description),
    id: "description",
    label: t('commons.challenge_post.form.description'),
    margin: "none",
    name: "description",
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: t('commons.challenge_post.form.description_placeholder'),
    rows: 2,
    slotProps: {
      htmlInput: {
        maxLength: 500
      },
      inputLabel: {
        shrink: true
      }
    },
    value: values.description,
    variant: "outlined"
  }), !challenge?.eventId && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_components.FileInput, {
    disablePreview: true,
    disabled: isSubmitting,
    emptyStateLabel: t('commons.challenge_post.form.photo'),
    file: file,
    onChange: setFile,
    size: "small",
    type: "image"
  }), file && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "flex-start",
    padding: "12px 12px 0 0",
    position: "relative"
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 80,
    src: 'url' in file ? file.url : URL.createObjectURL(file),
    style: {
      borderRadius: 4
    }
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    position: "absolute",
    right: 0,
    top: 0
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "rgba(0, 0, 0, 0.8)",
    borderRadius: "50%",
    color: "#fff"
  }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    title: t('commons.actions.remove')
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    color: "inherit",
    onClick: () => setFile(null),
    size: "small",
    sx: {
      padding: 0.5
    }
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, {
    fontSize: "small"
  })))))))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.125rem",
    fontWeight: 700
  }, t('commons.challenge_post.form.competition_type')), /*#__PURE__*/_react.default.createElement(_Typography2.default, null, t('commons.challenge_post.form.competition_type_description'))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    columnGap: 2,
    display: "flex",
    flexDirection: {
      xs: 'column',
      lg: 'row'
    },
    rowGap: 1
  }, _models.collaborationTypes.filter(({
    key
  }) => key !== 'teams' && key !== 'sites').map(({
    key,
    ...props
  }) => {
    const active = values.collaborationType === key;
    return /*#__PURE__*/_react.default.createElement(CustomChallengeFormTypeCard, _extends({
      active: active,
      disabled: challenge && (challenge.period !== 'future' || Boolean(challenge.eventId)) || false,
      key: key,
      onSelect: () => setFieldValue('collaborationType', key)
    }, props));
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.125rem",
    fontWeight: 700
  }, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.challenge_post.form.type"
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.challenge_post.form.type_description"
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    columnGap: 2,
    display: "flex",
    flexDirection: {
      xs: 'column',
      lg: 'row'
    },
    rowGap: 1
  }, _models.challengeTypes.map(({
    key,
    ...props
  }) => {
    if (key === 'journeysCount') return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: key
    });
    const active = values.type === key;
    return /*#__PURE__*/_react.default.createElement(CustomChallengeFormTypeCard, _extends({
      active: active,
      disabled: challenge && (challenge.period !== 'future' || Boolean(challenge.eventId)) || false,
      key: key,
      onSelect: () => setFieldValue('type', key)
    }, props));
  })), values.collaborationType === 'global' && /*#__PURE__*/_react.default.createElement(_TextField2.default, {
    fullWidth: true,
    required: true,
    disabled: isSubmitting || challenge?.period === 'current' || Boolean(challenge?.eventId),
    error: touched.target && Boolean(errors.target),
    id: "target",
    label: t('commons.challenge_post.form.target', {
      context: values.type === 'traveledDistance' ? 'distance' : values.type === 'cyclingDays' ? 'days' : values.type === 'journeysCount' || values.type === 'homeWorkJourneysCount' ? 'journeys' : ''
    }),
    margin: "dense",
    name: "target",
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: t('commons.challenge_post.form.target_placeholder', {
      context: values.type === 'traveledDistance' ? 'distance' : 'days'
    }),
    size: "small",
    slotProps: {
      htmlInput: {
        min: 0
      },
      input: {
        endAdornment: values.type === 'traveledDistance' && /*#__PURE__*/_react.default.createElement(_InputAdornment2.default, {
          position: "end"
        }, "km")
      },
      inputLabel: {
        shrink: true
      }
    },
    type: "number",
    value: values.target,
    variant: "outlined"
  })))), /*#__PURE__*/_react.default.createElement(_components.StickyBar, {
    drawerWidth: drawerWidth
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, challenge ? /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: isSubmitting,
    onClick: () => openCancelDialog(true),
    size: "large",
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    variant: "outlined"
  }, t('commons.actions.cancel')) : /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    component: Link,
    disabled: isSubmitting,
    relative: "path",
    size: "large",
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    to: prevPath,
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: !isValid || isSubmitting,
    size: "large",
    startIcon: isSubmitting ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_components.RocketIcon, null),
    type: "submit",
    variant: "contained"
  }, t(challenge ? 'commons.actions.save' : 'commons.challenge_post.actions.launch')))), /*#__PURE__*/_react.default.createElement(_cancelChallengeEditionDialog.default, {
    handleClose: handleCancelDialogClose,
    open: cancelDialogOpen
  }));
}
function CustomChallengeFormTypeCard({
  currentPartnerType,
  active,
  disabled,
  Icon,
  labelKey,
  descriptionKey,
  onSelect
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    component: _ButtonBase2.default,
    disabled: disabled,
    onClick: onSelect,
    sx: {
      alignItems: 'flex-start',
      bgcolor: active ? '#ECFBF4' : disabled ? '#F6F8FC' : 'transparent',
      border: !active && disabled ? 0 : `1px solid ${active ? '#2AC682' : '#DDE0E7'}`,
      borderRadius: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      justifyContent: 'flex-start',
      opacity: !active && disabled ? 0.6 : 1,
      padding: 2,
      textAlign: 'left'
    },
    width: {
      xs: '100%',
      lg: 'calc((100% - 48px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: 1
  }, Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    color: !active && disabled ? 'action' : 'primary'
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, t(labelKey, {
    context: currentPartnerType || ''
  }))), descriptionKey && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "caption"
  }, t(descriptionKey, {
    context: currentPartnerType || ''
  })));
}